import React from 'react';
import {EdgeCloudUrl} from '../../constants';

const ReadyToBuildSection = () => {
    return (
        <section className={'ReadyToBuild'}>
            <div className={'ReadyToBuild__inner'}>
                <h2 className={'ReadyToBuild__headline'}>Ready to Build?</h2>
                <p className={'ReadyToBuild__subtitle'}>
                    Whether you need GPU infrastructure for research or want to contribute
                    compute power to earn rewards, we have a path for you.
                </p>

                <div className={'ReadyToBuild__cards'}>
                    <div className={'ReadyToBuild__card'}>
                        <h3 className={'ReadyToBuild__card-title'}>I Need Compute</h3>
                        <p className={'ReadyToBuild__card-description'}>
                            Access flexible GPU infrastructure for AI training, inference, and high performance
                            workloads at radically lower costs.
                        </p>
                        <a className={'ReadyToBuild__card-cta ReadyToBuild__card-cta--filled'}
                           href={EdgeCloudUrl}
                           target={'_blank'}
                           rel={'noopener noreferrer'}
                        >
                            Create EdgeCloud Account
                        </a>
                    </div>

                    <div className={'ReadyToBuild__card'}>
                        <h3 className={'ReadyToBuild__card-title'}>I Have Compute to Share</h3>
                        <p className={'ReadyToBuild__card-description'}>
                            Contribute spare GPU capacity from your hardware and earn TFUEL rewards
                            for supporting global AI research.
                        </p>
                        <a className={'ReadyToBuild__card-cta ReadyToBuild__card-cta--outline'}
                           href={'/join'}
                        >
                            Join the Network
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ReadyToBuildSection;
